import React from 'react';
import Flex from 'components/common/Flex';
import { Card, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const IntestazioneProfiloUtente = () => {

  const csvcRole = useSelector((state) => state.utenteCorrente.csvcRole);
  const emailUsername = useSelector((state) => state.utenteCorrente.emailUsername);
  const name = useSelector((state) => state.utenteCorrente.name);
  
  const TitoloProfilo =
  csvcRole === `azienda`
      ? `Referente Aziendale: ${name}  [ ${emailUsername} ]`
      : csvcRole === `partner`
      ? `${name}  [ ${emailUsername} ] - Pannello di controllo`
      : `${name}  [ ${emailUsername} ] - Pannello di controllo master`

  return (
    <Card className="bg-100 shadow-none border mb-3" >
      <Card.Body className="py-0">
        <Row className="g-0 justify-content-between">
          <Col sm="12">
            <Flex  style={{margin:"1.5%"}}>
                <h7 className="text-primary center">{TitoloProfilo}</h7>
            </Flex>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default IntestazioneProfiloUtente;